import { GetBusinessCategories } from "_graphql/queries/__generated__/GetBusinessCategories";
import { getBusinessCategories } from "_graphql/visal/queries/class-of-business";
import { useQuery } from "@apollo/client";

export const useBusinessGroups = () => {
    const { data, ...rest } = useQuery<GetBusinessCategories>(getBusinessCategories, {});
    return {
        businessCategories: data?.getBusinessCategories ?? [],
        ...rest,
    };
};